import { VariableType } from 'json-to-graphql-query';

import { ProfileArgs, ProfileVariables } from './profile';
import { TokensArgs, TokensVariables } from './tokens';

export const RegisterVariables = {
  ...ProfileVariables,
  ...TokensVariables,
  termsIds: '[Int!]'
};

export const RegisterArgs = {
  ...ProfileArgs,
  ...TokensArgs,
  termsIds: new VariableType('termsIds')
};
